/* global window */

import './NewsOverview.scss';
import template from './NewsOverview.vhtml';
import $ from 'jquery';
import EventBus from '../eventBus';

export default {
	name: 'NewsOverview',
	template: template,
	props: {},
	data: () => ({
		items: null,
		featured: null,
		loading: true,
		total: null,
		showMore: false,
		category: '',
		pageParam: 1,
		currentPage: 1,
		currentTerm: '',
	}),
	computed: {
		pagination() {
			const pages = this.total / 9;
			return Math.ceil(pages);
		},
	},
	methods: {
		getItems() {
			this.loading = true;
			const query = window.location.search;
			$.get('/wp-json/gi/v1/news' + query)
				.then(result => {
					if (result.news.length > 3 && this.currentPage === 1) {
						this.featured = [
							{ ...result.news[0] },
							{ ...result.news[1] },
							{ ...result.news[2] },
						];
						const resultCopy = [...result.news];
						this.items = resultCopy.slice(3);
						this.total = result.total;
					} else {
						this.featured = null;
						this.items = result.news;
						this.total = result.total;
					}
				})
				.catch(e => {
					console.log(e);
				})
				.always(() => {
					// Fake loadtime to avoid content flickering
					setTimeout(() => {
						this.loading = false;
					}, 500);
				});
		},
		updateUrl() {
			const currentUrl = window.location.href;
			const baseUrl = currentUrl.split('?')[0];
			const newQuery = this.buildQueryString();
			window.history.pushState('', '', baseUrl + newQuery);
			this.getItems();
			window.scroll(0, 180);
		},
		buildQueryString() {
			const parameters = {
				newspage: this.currentPage,
				newsterm: this.currentTerm !== 0 ? this.currentTerm : '',
			};

			const queryString = Object.keys(parameters)
				.map(key => key + '=' + parameters[key])
				.join('&');

			return '?' + queryString;
		},
	},
	mounted() {
		this.getItems();
		EventBus.$on('term-filter', slug => {
			this.currentTerm = slug;
			this.currentPage = 1;
			this.updateUrl();
		});
		EventBus.$on('page-change', page => {
			this.currentPage = parseInt(page);
			this.updateUrl();
		});
	},
};
